import { Controller } from "@hotwired/stimulus"

const LABEL_RESET_DELAY = 1500

export default class extends Controller {
  static targets = ["copyLabel"]
  static values = { raw: String, copiedLabel: String, failedLabel: String }

  disconnect() {
    clearTimeout(this.labelResetTimeout)
  }

  expandAll() {
    this.setExpanded(true)
  }

  collapseAll() {
    this.setExpanded(false)
  }

  setExpanded(expanded) {
    this.element.querySelectorAll("details").forEach((node) => { node.open = expanded })
  }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.rawValue)
      this.flashLabel(this.copiedLabelValue)
    } catch {
      this.flashLabel(this.failedLabelValue)
    }
  }

  flashLabel(message) {
    if (!this.hasCopyLabelTarget) return

    const label = this.copyLabelTarget
    this.defaultLabel ??= label.textContent

    label.textContent = message
    clearTimeout(this.labelResetTimeout)
    this.labelResetTimeout = setTimeout(() => { label.textContent = this.defaultLabel }, LABEL_RESET_DELAY)
  }
}
